export const transitionModifiers={OPEN_IN_TAB:'OPEN_IN_TAB',OPEN_IN_MODAL:'OPEN_IN_MODAL'};